( function($) {
  $( document ).ready( function() {
    if( $( ".real-estate-form-container" ).has( ".gform_confirmation_wrapper" ).children().length > 0 ) {
      $( ".real-estate-form-container .form-column .legal-text" ).hide();
      $( ".real-estate-form-container .additional-info-container" ).hide();
    }
  } );
} )( jQuery );
